import api from "../config/ApiConfig";
import { jwtDecode } from "jwt-decode";

export const authService = {
  // Inscription
  async register(userData) {
    const response = await api.post("/register", userData);
    if (response.data.data && response.data.data.token) {
      this.setAuthData(response.data.data);
    }
    return response.data;
  },

  // Connexion
  async login(email, password) {
    const response = await api.post("/login", { email, password });
    if (response.data.data && response.data.data.token) {
      this.setAuthData(response.data.data);
    }
    return response.data;
  },

  // Connexion avec Google
  async googleLogin(googleCredential) {
    const response = await api.post("/google-login", { credential: googleCredential });

    // Si le profil est incomplet, stocker temporairement les données
    if (response.data.data && response.data.data.profileIncomplete) {
      localStorage.setItem("tempGoogleUserData", JSON.stringify(response.data.data.user));
      return { profileIncomplete: true };
    }

    // Sinon, connexion normale
    if (response.data.data && response.data.data.token) {
      this.setAuthData(response.data.data);
    }
    return response.data;
  },

  // Compléter le profil après connexion Google
  async completeProfile(profileData) {
    const response = await api.post("/complete-profile", profileData);
    if (response.data.data && response.data.data.token) {
      this.setAuthData(response.data.data);
    }
    return response.data;
  },

  // Déconnexion
  logout() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    window.location.href = "/login";
  },

  // Stocker les données d'authentification
  setAuthData(data) {
    localStorage.setItem("authToken", data.token);
    localStorage.setItem("userData", JSON.stringify(data.user));
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated() {
    const token = localStorage.getItem("authToken");
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  },

  // Récupérer l'utilisateur actuel
  getCurrentUser() {
    const userData = localStorage.getItem("userData");
    return userData ? JSON.parse(userData) : null;
  },
};
